export const mockDonationDetail = {
  object: 'donation_match_request',
  data: {
    id: 'staging_donationmatchrequest_000000CkwtczFFO3cym49MBCPzzPM',
    status: 'processing',
    partnerId: 'staging_partner_000000CjaEDvxVBvj5UJ9CvcKovGC',
    accountId: 'staging_account_000000CkLTwPW1loC3jdFgvBrxbbU',
    createdBy: 'staging_account_000000CkLTwPW1loC3jdFgvBrxbbU',
    createdAt: '2023-12-21T11:26:30.776Z',
    amount: {
      amount: 1000,
      currency: 'AUD'
    },
    organisationId: null,
    organisationDetails: {
      countryCode: null,
      name: 'Dog Trust',
      registryId: null,
      registryName: null,
      websiteUrl: 'dog-trust-wpg.com'
    },
    approvedBy: null,
    approvedAt: null,
    rejectedBy: null,
    rejectedAt: null,
    rejectedReason: null,
    donationMadeBy: null
  }
}

export const mockRejectedDonationDetail = {
  ...mockDonationDetail,
  data: {
    ...mockDonationDetail.data,
    status: 'rejected',
    rejectedBy: 'staging_account_000000CdP8NCOL5QfnBytEBGugcYy',
    rejectedAt: '2023-12-22T11:26:30.776Z',
    rejectedReason: 'Receipt is ineligible'
  }
}

export const mockRevertedDonationDetail = {
  ...mockRejectedDonationDetail,
  data: {
    ...mockRejectedDonationDetail.data,
    status: 'processing',
    rejectedBy: null,
    rejectedAt: null,
    rejectedReason: null,
    validationSubmissionId: null
  }
}
